// @flow
import * as React from 'react';

export type Locales = {
  [string]: {
    label: string,
    LANG: string,
    languageNativeName: string,
    PAYS: number,
    moment: string,
  },
};

function getUrl(locale) {
  return '/?locale=' + locale;
}

function getLocales(localesConfig) {
  return Object.keys(localesConfig);
}

function getSwitchLocale(localesConfig, currentLocale) {
  return getLocales(localesConfig).filter(locale => locale !== currentLocale)[0];
}

class SwitchLanguage {
  localesConfig: Locales;
  currentLocale: string;

  constructor(availableLocalesConfig: Locales, currentLocale: string) {
    this.localesConfig = availableLocalesConfig;
    this.currentLocale = currentLocale;
  }

  getAvailableLocales() {
    return this.localesConfig;
  }

  getCurrentLocaleLabel() {
    return this.localesConfig[this.currentLocale].label;
  }

  getSwitchLocaleLabel() {
    return this.localesConfig[getSwitchLocale(this.localesConfig, this.currentLocale)].label;
  }

  getLabelWithUrls(): Array<*> {
    return Object.keys(this.localesConfig).map(locale => {
      return {
        label: this.localesConfig[locale].label,
        countryCode: this.localesConfig[locale].PAYS,
        langCode: this.localesConfig[locale].LANG,
        languageNativeName: this.localesConfig[locale].languageNativeName,
        moment: this.localesConfig[locale].moment,
        url: getUrl(locale),
      };
    });
  }

  getSwitchUrl() {
    return getUrl(getSwitchLocale(this.localesConfig, this.currentLocale));
  }

  isMultiLanguage() {
    return getLocales(this.localesConfig).length > 1;
  }

  /* todo: es6 : make this class iterable */
  map(mapper: () => React.Node) {
    const mapping = () => {
      return this.getLabelWithUrls().map(mapper);
    };
    return this.or(mapping.bind(this));
  }

  or(callback: () => React.Node) {
    return this.isMultiLanguage() ? callback() : <noscript />;
  }
}

export default SwitchLanguage;
